//Layouts
import TheHeader from "@/layouts/TheHeader.vue";
import TheContent from "@/layouts/TheContent.vue";
import TheNavBar from "@/layouts/TheNavBar.vue";
import TheFooter from "./layouts/TheFooter.vue";

//components
import HGrid from "@/components/grid/HGrid.vue";
import HPagination from "@/components/grid/HPagination.vue";
import HCombobox from "@/components/combobox/HCombobox.vue";
import HInput from "@/components/input/HInput.vue";
import HTextarea from "@/components/input/HTextarea.vue";
import HDropdown from "@/components/dropdown/HDropdown.vue";
import HDropdownV2 from "@/components/dropdown/HDropdownV2.vue";
import HButton from "@/components/button/HButton.vue";
import HCheckbox from "@/components/checkbox/HCheckbox.vue";

import HDialog from "@/components/dialog/HDialog.vue";
import HLoading from "@/components/loading/HLoading.vue";

import HComment from "@/components/comment/HComment.vue";
import * as Icons from "@ant-design/icons-vue"; // Import icon library

export const installComponents = (app) => {
  app.component("the-header", TheHeader);
  app.component("the-content", TheContent);
  app.component("the-navbar", TheNavBar);
  app.component("the-footer", TheFooter);

  app.component("h-grid", HGrid);
  app.component("h-pagination", HPagination);
  app.component("h-combobox", HCombobox);
  app.component("h-input", HInput);
  app.component("h-textarea", HTextarea);
  app.component("h-dropdown", HDropdown);
  app.component("h-dropdown-v2", HDropdownV2);
  app.component("h-button", HButton);
  app.component("h-dialog", HDialog);
  app.component("h-loading", HLoading);
  app.component("h-checkbox", HCheckbox);
  app.component("h-comment", HComment);

  Object.keys(Icons).forEach((key) => {
    app.component(key, Icons[key]);
  });
};
